import React, {useEffect} from 'react';
// import PropTypes from 'prop-types';
import {ViewServiceDeliveryList} from '../Checkout/viewServiceDeliveryList';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {SELECTOR_FULFILLMENT_CURRENT} from '../../redux/selectors/fulfillments';
import clsx from 'clsx';
import AppButton from '../../components/AppButton';

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
}));

ServiceDelivery.propTypes = {};

function ServiceDelivery(props) {
  const fulfillment = useSelector(SELECTOR_FULFILLMENT_CURRENT);

  const classes = useStyles();
  const match = useRouteMatch('/checkout/:section');
  const history = useHistory();

  useEffect(() => {
    if (match.params.section === 'pay' && !fulfillment) {
      history.push('/checkout/delivery');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match, fulfillment]);

  return (
    <React.Fragment>
      <Box
        className={clsx({
          [classes.hidden]: match.params.section !== 'delivery',
        })}
      >
        <ViewServiceDeliveryList />
      </Box>
      <Box
        display={'flex'}
        justifyContent={'flex-end'}
        className={clsx({
          [classes.hidden]: match.params.section !== 'delivery',
        })}
      >
        <AppButton
          round
          disableElevation
          color="secondary"
          variant="contained"
          type={'submit'}
          onClick={() => {
            history.push('/checkout/pay');
          }}
          {...(fulfillment ? {} : {disabled: true})}
        >
          Continuar
        </AppButton>
      </Box>
    </React.Fragment>
  );
}

export default ServiceDelivery;
